// Module
var code = "<script>let $panelServiceInfo</script> <molecule-panel-view include-show-all-link=\"false\" panel-icon=\"info\" panel-items=\"$panelServiceInfo.linkList\" panel-title=\"{{ 'TR_040419-de923e_TR' | translate }}\"></molecule-panel-view> ";
// Exports
module.exports = code;